import A2AIntegrationPage from './A2AIntegrationPage';
export default A2AIntegrationPage;
